import { render, staticRenderFns } from "./menuBtn.vue?vue&type=template&id=55a89d2b&scoped=true&"
import script from "./menuBtn.vue?vue&type=script&lang=js&"
export * from "./menuBtn.vue?vue&type=script&lang=js&"
import style0 from "./menuBtn.vue?vue&type=style&index=0&id=55a89d2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a89d2b",
  null
  
)

export default component.exports